/* import __COLOCATED_TEMPLATE__ from './sentiment-option.hbs'; */
import Component from '@glimmer/component';

export default class SentimentOptionComponent extends Component {}
